import { FieldValue } from '../api/types';

interface RecordDiffProps {
  changes: FieldValue[];
  title?: string;
}

export function RecordDiff({ changes, title }: RecordDiffProps) {
  if (changes.length === 0) {
    return <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem' }}>No field changes in this version.</p>;
  }

  return (
    <div>
      {title && <h4 style={{ marginBottom: '0.5rem' }}>{title}</h4>}
      <table aria-label="Field-level changes">
        <thead>
          <tr>
            <th scope="col">Field</th>
            <th scope="col">Previous Value</th>
            <th scope="col">New Value</th>
          </tr>
        </thead>
        <tbody>
          {changes.map((change, idx) => (
            <tr key={`${change.field}-${idx}`}>
              <td style={{ fontWeight: 500 }}>{change.field}</td>
              <td>
                {change.oldValue !== null ? (
                  <span
                    style={{
                      background: '#fde7e7',
                      padding: '0.1rem 0.3rem',
                      borderRadius: '3px',
                      fontFamily: 'monospace',
                      fontSize: '0.8rem',
                      wordBreak: 'break-all',
                    }}
                  >
                    {change.oldValue}
                  </span>
                ) : (
                  <span style={{ color: 'var(--color-text-muted)', fontStyle: 'italic' }}>null</span>
                )}
              </td>
              <td>
                {change.newValue !== null ? (
                  <span
                    style={{
                      background: '#e6f4ea',
                      padding: '0.1rem 0.3rem',
                      borderRadius: '3px',
                      fontFamily: 'monospace',
                      fontSize: '0.8rem',
                      wordBreak: 'break-all',
                    }}
                  >
                    {change.newValue}
                  </span>
                ) : (
                  <span style={{ color: 'var(--color-text-muted)', fontStyle: 'italic' }}>null</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
